import React from 'react';
import { IconType } from 'react-icons';

interface SectionHeaderProps {
  icon: IconType;
  title: string;
  iconColor?: string;
  showEditButton?: boolean;
  isEditMode?: boolean;
  onEditToggle?: () => void;
  editButtonText?: string;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({
  icon: Icon,
  title,
  iconColor = 'text-blue-600',
  showEditButton = false,
  isEditMode = false,
  onEditToggle,
  editButtonText,
}) => {
  return (
    <div className="flex items-center justify-between mb-4">
      <h2 className="text-lg font-semibold text-gray-900 flex items-center">
        <Icon className={`mr-2 ${iconColor}`} />
        {title}
      </h2>
      {showEditButton && onEditToggle && (
        <button
          type="button"
          onClick={onEditToggle}
          className="inline-flex items-center px-3 py-2 border border-gray-300 text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
        >
          <svg
            className="mr-1 w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
            />
          </svg>
          {editButtonText || (isEditMode ? 'Cancel Edit' : 'Edit')}
        </button>
      )}
    </div>
  );
};

export default SectionHeader;
